




















































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Video from "@/components/Video.vue";
import Pdf from "@/components/Pdf.vue";
import NextPrevBtn from "@/components/NextPrevBtn.vue";
import Footer from "@/components/Footer.vue";
@Component({
  components: {
    Header,
    Menu,
    Video,
    Pdf,
    NextPrevBtn,
    Footer,
  },
})
export default class MeetingFundamental extends Vue {
  protected pdfMeeting = [
    {
      PdfLink: "/pdf_OWcom/MeetingChapter1.pdf",
      PdfDownload: "OrganiserReunion",
      TxtPdf: "Chapitre 1 : organiser une réunion",
    },
    {
      PdfLink: "/pdf_OWcom/MeetingChapter2.pdf",
      PdfDownload: "AnimerReunion",
      TxtPdf: "Chapitre 2 : animer une réunion",
    },
    {
      PdfLink: "/pdf_OWcom/MeetingChapter3.pdf",
      PdfDownload: "CommunicationReunion",
      TxtPdf: "Chapitre 3 : la communication en réunion",
    },
    {
      PdfLink: "/pdf_OWcom/MeetingReport.pdf",
      PdfDownload: "CompteRenduReunion",
      TxtPdf: "Rédiger un compte rendu de réunion",
    },
  ];

  protected nxtprevMeetingFundamental = {
    BoolPrev: false,
    BoolNext: true,
    PrevImage: "",
    NextImage: "/thumbnail1.png",
    PrevLink: "",
    NextLink: "/Conduite_Reunion/Astuces",
  };
}
